import { Button, Col, Form, Input, Row, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { createWorkspace } from '../../api/workspace';

export enum WORKSPACE_VISIBILITY {
  Private = 'private',
  Public = 'public',
}

const workspaceVisibilityOptions = [
  { value: WORKSPACE_VISIBILITY.Private, label: 'Private' },
  { value: WORKSPACE_VISIBILITY.Public, label: 'Public' },
];
export default function WorkspaceOnboarding() {
  const [initOnboardingForm] = Form.useForm();
  const navigate = useNavigate();
  const initialFormState = {
    visibility: WORKSPACE_VISIBILITY.Public,
    name: 'General',
  };

  interface onFinishStructure {
    name: string;
    visibility: WORKSPACE_VISIBILITY;
  }

  const onFinish = async (values: onFinishStructure) => {
    // We need to trigger two API calls. One to update user with his full name and another to create an org and give
    // user an owner access to it.
    await createWorkspace(values.name, values.visibility);

    navigate('/');
  };

  return (
    <>
      <div className="onboarding-page-wrapper">
        <h2 className="text-center">Taskonio</h2>

        <h1>Set up your workspace</h1>

        <Row justify="center" align="middle">
          <Col span={8}>
            <Form
              form={initOnboardingForm}
              name="initial-onboarding"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              onFinish={onFinish}
              // onFinishFailed={ onFinishFailed }
              autoComplete="off"
              layout="vertical"
              requiredMark="optional"
              initialValues={initialFormState}
            >
              <Form.Item
                label="Workspace name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Please input your workspace name!',
                  },
                ]}
                wrapperCol={{ sm: 24 }}
              >
                <Input placeholder="Enter your workspace name" size="large" />
              </Form.Item>

              <Form.Item
                label="Workpsace visibility"
                name="visibility"
                rules={[
                  {
                    required: true,
                    message: 'Workspace visibility is required option!',
                  },
                ]}
                wrapperCol={{ sm: 24 }}
              >
                <Select options={workspaceVisibilityOptions} size="large" />
              </Form.Item>

              <Form.Item wrapperCol={{ sm: 24 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  shape="round"
                  className="onboarding-submit-button"
                >
                  Continue to Taskonio
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <p className="text-center">
              <a href="/">Set up later</a>
            </p>
          </Col>
        </Row>
      </div>
    </>
  );
}
